/**
 * @prettier
 */
import { connect } from 'react-redux';
import { fetchZoomPlanType } from 'actions/ZoomActions';
import { getZoomPlanType } from 'selectors/zoom';

import ZoomPlanStatusModule from './ZoomPlanStatusModule';

const mapState = state => ({
  planStatus: getZoomPlanType(state),
});

const mapDispatch = dispatch => ({
  fetchZoomPlan: () => dispatch(fetchZoomPlanType()),
});

export default connect(mapState, mapDispatch)(ZoomPlanStatusModule);



// WEBPACK FOOTER //
// ./src/components/manage/VirtualEvents/ZoomPlanStatusModule/index.js